module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1004-eb500aa8327be260cf8087d1063b0be4.png";